<p-card class="mx-2">
  <p-accordion [multiple]="true">
    <p-accordionTab
      header="{{ 'AutoPrintSetting.HeaderTable.SearchForm.Header' | translate }}"
      [(selected)]="isOpenedSettingSearchFormTab"
    >
      <ng-content *ngTemplateOutlet="settingSearchFormTemplate"></ng-content>
    </p-accordionTab>
    <p-accordionTab
      header="{{ 'AutoPrintSetting.HeaderTable.Header' | translate }}"
      [(selected)]="isOpenedSettingHeaderTab"
    >
      <ng-content *ngTemplateOutlet="settingHeaderTemplate"></ng-content>
    </p-accordionTab>
  </p-accordion>
</p-card>

<ng-template #settingSearchFormTemplate>
  <form [formGroup]="searchFormGroup">
    <!-------------------------------------- Form Field ---------------------------------------------->
    <div class="p-fluid formgrid grid">
      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formFacility">{{ 'AutoPrintSetting.HeaderTable.SearchForm.Column.Facility' | translate }}</label>
        <laas-facility-dropdown 
          [isSingle]="true" 
          formControlName="facility">
        </laas-facility-dropdown>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formDeliveryType">{{ 'AutoPrintSetting.HeaderTable.SearchForm.Column.DeliveryType' | translate }}</label>
        <p-multiSelect
          inputId="formDeliveryType"
          appendTo="body"
          optionLabel="label"
          optionValue="value"
          formControlName="deliveryTypes"
          [options]="deliveryTypeOptions"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          filterPlaceHolder="{{
            'Common.PlaceHolder.EnterSearchCondition' | translate
          }}"
        ></p-multiSelect>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formDocType">{{ 'AutoPrintSetting.HeaderTable.SearchForm.Column.DocType' | translate }}</label>
        <p-multiSelect
          inputId="formDocType"
          appendTo="body"
          optionLabel="label"
          optionValue="value"
          formControlName="docTypes"
          [options]="docTypeOptions"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          filterPlaceHolder="{{
            'Common.PlaceHolder.EnterSearchCondition' | translate
          }}"
        ></p-multiSelect>
      </div>
    </div>
    <!-------------------------------------- Form Button ---------------------------------------------->
    <div>
      <button
        pButton
        label="{{ 'Common.Button.Search' | translate }}"
        (click)="searchBtnClick()"
      ></button>
      <button
        pButton
        label="{{ 'Common.Button.Reset' | translate }}"
        class="p-button-secondary ml-2"
        (click)="resetBtnClick()"
      ></button>
    </div>
  </form>
</ng-template>

<ng-template #settingHeaderTemplate>
  <div class="mt-2">
    <laas-data-table
      #headerTable
      [dataKey]="'rowId'"
      [tableKey]="headerPreferenceKey"
      [value]="settingHeaderData"
      [defaultColumns]="columnOfAutoPrintSetting"
      [loading]="isHeaderTableLoading"
      [lazy]="true"
      [editPermission]="editPermissionCode"
      [createNewRow]="createNewRow"
      [inputValid]="dataInputValid"
      (createRow)="createRow($event)"
      (savedData)="saveData($event)"
      (restoreData)="restoreData()"
      (tableOnPage)="tablePageChange($event)"
      (tableOnSort)="tableSort($event)"
      (onRowSelect)="onRowSelect($event)"
      >

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'isDelete'">
              <div class="overflow-text">
                {{ rowData[col.field] | toggleValue | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'isLoopGroup'">
              <div class="overflow-text">
                {{ rowData[col.field ] | loopGroupDecoder | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'__action'">
              -
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>

          </ng-container>
        </td>
      </ng-template>

      <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">

          <ng-container *ngSwitchCase="'deliveryType'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}"
              [filter]="true"
              [options]="deliveryTypeOptions"
              [(ngModel)]="rowData[col.field]">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'docType'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}"
              [filter]="true"
              [options]="docTypeOptions"
              [(ngModel)]="rowData[col.field]">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'numberOfCopies'">
            <div class="overflow-text">
              <p-inputNumber
                [(ngModel)]="rowData[col.field]"
                mode="decimal"
                [min]="0"
                [max]="30"
                (onInput)="onInputHandle($event, rowData)">
              </p-inputNumber>
            </div>
            <small *ngIf="rowData[col.field] == null" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'printOrder'">
            <div class="overflow-text">
              <p-inputNumber
                [(ngModel)]="rowData[col.field]"
                mode="decimal"
                [min]="0"
                [max]="30"
                (onInput)="onInputHandle($event, rowData)">
              </p-inputNumber>
            </div>
            <small *ngIf="rowData[col.field] == null" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'isLoopGroup'">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [options]="isLoopGroupOptions"
              [(ngModel)]="rowData[col.field]">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>
          <ng-container *ngSwitchCase="'isDelete'">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [options]="isDeleteOptions"
              [(ngModel)]="rowData[col.field]">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'__action'">
            <i *ngIf="true" class="pi pi-trash ml-2 mt-2" (click)="deleteBtnClick(rowData.seqNo)"></i>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>

        </ng-container>
      </ng-template>

      <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'isDelete'">
            <div class="overflow-text">
              {{ rowData[col.field] | toggleValue | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'isLoopGroup'">
            <div class="overflow-text">
              {{ rowData[col.field ]| loopGroupDecoder | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'__action'">
            <i *ngIf="true" class="pi pi-trash ml-2 mt-2" (click)="deleteBtnClick(rowData.seqNo)"></i>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
        </ng-container>
      </ng-template>
    </laas-data-table>
  </div>
</ng-template>

